export class MultipleSelectedRequest {
  chooseId: number;
  selectedIds: number[] = new Array();
  // buyer = 0;
  prospect = 0;
}
